(function ($) {

    $(document).ready(function () {

        if ($('.intro-2').length) {

            $('.intro-2 .item-wrap').hover(function () {

                    if ($(this).parent('.items').hasClass('hover')) {

                    } else {
                        $(this).parent('.items').addClass('hover');
                        $(this).addClass('active');

                        if ($(window).width() < 1025) {
                            $(this).find('.content').slideDown();
                        }

                    }

                }, function () {
                    if ($(window).width() < 1025) {
                        $(this).parent('.items').removeClass('hover');
                        $(this).removeClass('active');
                        $(this).find('.content').slideUp();
                    }
                }
            );


            $('.intro-2 .items ').on('mouseleave touchend', function () {
                    if ($(window).width() > 1024) {
                        $(this).removeClass('hover');
                        $('.intro-2 .item-wrap').removeClass('active');
                        $('.intro-2 .item-wrap .content').slideUp();
                    }
                }
            );


        }

    });

})
(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/hotels-travel_agents-homepage-sect.js